import clsx from "clsx";
import { FunctionComponent, ReactNode } from "react";

import styles from "./card.module.scss";

type CardContainer = {
  classNameOuterContainer?: string | false;
  classNameInnerContainer?: string | false;
  onBlur?: () => void;
  onClick?: () => void;
  hoverable?: boolean;
  postChildren?: ReactNode;
  "data-testid"?: string;
};

const CardContainer: FunctionComponent<CardContainer> = ({
  classNameOuterContainer,
  classNameInnerContainer,
  onBlur,
  onClick,
  hoverable = true,
  children,
  postChildren,
  "data-testid": dataTestId
}) => (
  <div
    className={clsx(styles.card, classNameOuterContainer)}
    tabIndex={0}
    onBlur={onBlur}
    onClick={onClick}
    data-testid={dataTestId ? `${dataTestId}_expand_toggle` : null}
  >
    <div
      className={clsx(
        styles.card_header,
        classNameInnerContainer,
        hoverable && styles.card_hoverable
      )}
    >
      {children}
    </div>
    {postChildren}
  </div>
);

export default CardContainer;
